

equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {
    $el = $(this);
    $($el).height('auto')
    var topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

  $(document).ready(function(){
      equalheight('.CollectionMain .ProductItem');
      $(window).on('resize', function(){
        equalheight('.CollectionMain .ProductItem');
      });
  
    $('.ls_text-close').click(function(){
      $('.ls_text').remove();
    });
  
});


if($('.product-accordion').length){
    var acc = document.getElementsByClassName("accordion");
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 20 + "px";
          panel.style.height = panel.scrollHeight + 20 + "px";
        }
      });
    }

  
}


function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


$(function(){
  if($('.session-episodes').length){
    $('.session-episodes').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows:true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true
                }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
  }

    $('#session_select').append('<option>Select</option>');
      $('.session-episodes').each(function( index ) {
      $('#session_select').append('<option value="'+$(this).attr('id')+'">'+$(this).attr('data-id')+'</option>');
    });

     $('body').on('change', '#session_select', function(e){
     
          var id = $(this).val();
          // target element
          var $id = $('#'+id);
          if ($id.length === 0) {
            return;
          }
          e.preventDefault();
          var pos = $id.offset().top - $('#section-header').height() - 60;
          // animated top scrolling
          $('body, html').animate({scrollTop: pos})

      });
  
  $('body').on('click', '.SessionPopup__close', function(e){
    e.preventDefault();
    $('.SessionPopup__overlay.leadform').removeClass('active');
  });

  $('body').on('click','.session-episode-imgbox',function(){
    
     if($('.SessionPopup__overlay.leadform').hasClass( "active" )){
        $('.session-popup-left iframe').attr('src',$(this).find('.episode-image').attr('data-src'));
        $('.session-popup-right .episode-name').html($(this).parents('.session-episode').find('.episode-name').html());
        $('.session-popup-right .episode-date').html($(this).parents('.session-episode').find('.episode-date').html());
        $('.SessionPopup__overlay.leadform').addClass('active');
     }else{
          $('.session-popup-left iframe').attr('src',$(this).find('.episode-image').attr('data-src'));
          $('.session-popup-right .episode-name').html($(this).parents('.session-episode').find('.episode-name').html());
          $('.session-popup-right .episode-date').html($(this).parents('.session-episode').find('.episode-date').html());
          $('.session-episodes-popup').html('');
       if($(this).parents('.session-episodes').find('.session-episode.slick-slide').length){
       
          $(this).parents('.session-episodes').find('.session-episode').not('.slick-cloned').each(function( index ) {
            $('.session-episodes-popup').append('<div class="session-episode">'+$( this ).html()+'</div>');
          });
         
           if($('.session-episodes-popup').hasClass('slick-initialized')) {
             $('.session-episodes-popup').slick('unslick');
           }

           $('.session-episodes-popup').slick({
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  dots: false,
                  arrows:true,
                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
          });
       
         }
       
         $('.SessionPopup__overlay.leadform').addClass('active');  
       }
    
    });

   
});
if($('.AnnouncementBar-section').length){
  $('.AnnouncementBar-section').show();
  $('.AnnouncementBar-section').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows:false,
             autoplay: true,
          autoplaySpeed: 3000,
        });
}